var map = {
	"./icon-close.png": "ab5e",
	"./icon-product-color-default.png": "63e0",
	"./icon-shop-btn.png": "eed5",
	"./icon-shop-manage-asset-center.png": "5d6d",
	"./icon-shop-manage-attention-blue.png": "8a0e",
	"./icon-shop-manage-btn-edit.png": "8119",
	"./icon-shop-manage-recive.png": "ddab",
	"./icon-shop-manage-reject.png": "6398",
	"./icon-shop-menu-money.png": "9562",
	"./icon-shop-menu-order-list.png": "5cc1",
	"./icon-shop-menu-products.png": "e545",
	"./icon-shop-menu-store.png": "de24",
	"./icon-shop-order-copy.png": "b4b1",
	"./icon-shop-order-logistics.png": "a84b",
	"./icon-shop-order-remark-blue.png": "9e03",
	"./icon-shop-order-remark-edit.png": "6ab3",
	"./icon-shop-order-remark-empty.png": "7d47",
	"./icon-shop-order-remark-green.png": "e265",
	"./icon-shop-order-remark-red.png": "be30",
	"./icon-shop-order-remark-yellow.png": "9cae",
	"./icon-shop-order-service.png": "6682",
	"./icon-shop-order-voucher.png": "91d3",
	"./icon-shop-search.png": "1617",
	"./icon-shop-share.png": "b638",
	"./img-shop-order-logistics.png": "c619"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff2b";